<template>
  <header class="header">
    <div class="header-container">
      <Logo />
      <nav class="nav links">
        <!-- <a v-if="$production.toUpperCase() !== 'AIR'" target="_blank" rel="noopener noreferrer" :href="AIR_URL" class="link" @click="navOnClick(AIR_URL)">
          {{ $t('AIR.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}" class="link">
          {{ $t('AIR.TITLE') }}
        </RouterLink> -->
        <a v-if="$production.toUpperCase() !== 'LISTEN'" target="_blank" rel="noopener noreferrer" :href="LISTEN_URL" class="link" @click="navOnClick(LISTEN_URL)">
          {{ $t('LISTEN.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'LISTEN'}" class="link"
        >
          {{ $t('LISTEN.TITLE') }}
        </RouterLink>
        <a v-if="$production.toUpperCase() !== 'READ'" target="_blank" rel="noopener noreferrer" :href="READ_URL" class="link" @click="navOnClick(READ_URL)">
          {{ $t('READ.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'READ'}" class="link"
        >
          {{ $t('READ.TITLE') }}
        </RouterLink>
        <a v-if="$production.toUpperCase() !== 'CONCERT'" target="_blank" rel="noopener noreferrer" :href="CONCERT_URL" class="link" @click="navOnClick(CONCERT_URL)">
          {{ $t('CONCERT.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'CONCERT'}" class="link"
        >
          {{ $t('CONCERT.TITLE') }}
        </RouterLink>
        <a target="_blank" rel="noopener noreferrer" :href="WATCH_URL" class="link" @click="navOnClick(WATCH_URL)">
          {{ $t('WATCH.TITLE') }}
        </a>
        <a target="_blank" rel="noopener noreferrer" :href="MUZIK_SHOP_URL" class="link" @click="navOnClick(MUZIK_SHOP_URL)">
          {{ $t('MUZIK_SHOP.TITLE') }}
        </a>
        <!-- <RouterLink :to="{ name: 'membership', params: { locale: $i18n.localePath() }}" class="link link-yellow">
          {{ $t('MEMBERSHIP.SUB_TITLE') }}
        </RouterLink> -->
      </nav>
      <nav class="nav info">
        <a
          href="https://goo.gl/forms/PYsQKE6dewZqvXrG2"
          target="_blank"
          rel="noopener noreferrer"
          class="report"
        >
          {{ $t('COMMON.REPORT') }}
        </a>
        <template v-if="!isAuthenticated && !profileLoading && !redirectPending">
          <SearchButton :btn-type="'icon'" />
          <RouterLink
            :to="{ name: 'signin', params: {locale: $i18n.localePath()}, query: {redirectURL: currentURL}}"
            :title="$t('AUTH.SIGN_IN')"
            class="link signin"
          >
            {{ $t('AUTH.SIGN_IN') }}
          </RouterLink>
          <RouterLink
            :to="{ name: 'signin', params: {locale: $i18n.localePath()}, query: {type: 'SIGN_UP', redirectURL: currentURL}}"
            :title="$t('AUTH.GET_STARTED')"
            class="link signup"
          >
            {{ $t('AUTH.GET_STARTED') }}
          </RouterLink>
        </template>
        <template v-else-if="isAuthenticated && !profileLoading">
          <div class="searchBtn-container">
            <SearchButton />
          </div>
          <div class="avatar-container">
            <Avatar :on-click="toggleDropdown" />
          </div>
        </template>
        <template v-else-if="redirectPending">
          <Loader :width="64" :height="64" />
        </template>
      </nav>
      <nav class="nav mobile">
        <a
          href="https://goo.gl/forms/PYsQKE6dewZqvXrG2"
          target="_blank"
          rel="noopener noreferrer"
          class="report"
        >
          {{ $t('COMMON.REPORT') }}
        </a>
        <SearchButton />
        <a title="menu" class="menu" @click="toggleMobileDropdown">
          <i class="material-icons">
            menu
          </i>
        </a>
      </nav>
    </div>
    <Transition name>
      <div v-if="showDropdown" class="header-dropdown">
        <div class="header-dropdown-container">
          <div class="user">
            <a title="user--avatar" class="user--avatar pointer" @click="goToMember">
              <div
                v-cover-lazy-loader
                :data-src="profile.avatar"
                :data-default-src="'/img/img-default/img-user-default-s.png'"
                :data-hide="true"
                class="avatar"
              />
            </a>
            <a title="name" class="user--name pointer" @click="goToMember">
              {{ profile.name }}
            </a>
          </div>
          <div class="link pointer" @click="goToNotification">
            <i class="icon material-icons">
              notifications
            </i>
            <span class="text">
              {{ $t('MEMBER.NOTIFICATION.TITLE') }}
            </span>
          </div>
          <div class="link pointer" @click="logout">
            <i v-if="!siginOutLoading" class="icon material-icons">
              input
            </i>
            <span v-if="!siginOutLoading" class="text">
              {{ $t('AUTH.SIGN_OUT') }}
            </span>
            <Loader v-else :width="55" :height="55" />
          </div>
        </div>
        <div class="dropdownBackdrop" @click="toggleDropdown(false)" />
      </div>
    </Transition>
    <Transition name="expand">
      <div v-if="showMobileDropdown" class="header-dropdown--mobile">
        <!-- <a v-if="$production.toUpperCase() !== 'AIR'" target="_blank" rel="noopener noreferrer" :href="AIR_URL" class="link" @click="navOnClick(AIR_URL)">
          {{ $t('AIR.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}" class="link">
          {{ $t('AIR.TITLE') }}
        </RouterLink> -->
        <a v-if="$production.toUpperCase() !== 'LISTEN'" target="_blank" rel="noopener noreferrer" :href="LISTEN_URL" class="link" @click="navOnClick(LISTEN_URL)">
          {{ $t('LISTEN.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'LISTEN'}" class="link"
        >
          {{ $t('LISTEN.TITLE') }}
        </RouterLink>
        <a v-if="$production.toUpperCase() !== 'READ'" target="_blank" rel="noopener noreferrer" :href="READ_URL" class="link" @click="navOnClick(READ_URL)">
          {{ $t('READ.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'READ'}" class="link"
        >
          {{ $t('READ.TITLE') }}
        </RouterLink>
        <a v-if="$production.toUpperCase() !== 'CONCERT'" target="_blank" rel="noopener noreferrer" :href="CONCERT_URL" class="link" @click="navOnClick(CONCERT_URL)">
          {{ $t('CONCERT.TITLE') }}
        </a>
        <RouterLink v-else :to="{ name: 'index', params: { locale: $i18n.localePath() }}"
                    :class="{'active': $production.toUpperCase() === 'CONCERT'}" class="link"
        >
          {{ $t('CONCERT.TITLE') }}
        </RouterLink>
        <a target="_blank" rel="noopener noreferrer" :href="WATCH_URL" class="link" @click="navOnClick(WATCH_URL)">
          {{ $t('WATCH.TITLE') }}
        </a>
        <a target="_blank" rel="noopener noreferrer" :href="MUZIK_SHOP_URL" class="link" @click="navOnClick(MUZIK_SHOP_URL)">
          {{ $t('MUZIK_SHOP.TITLE') }}
        </a>
        <RouterLink :to="{ name: 'membership', params: { locale: $i18n.localePath() }}" class="link">
          {{ $t('MEMBERSHIP.SUB_TITLE') }}
        </RouterLink>
        <RouterLink
          v-if="!isAuthenticated && !profileLoading"
          :to="{ name: 'signin', params: {locale: $i18n.localePath()}, query: {redirectURL: currentURL}}"
          :title="$t('AUTH.SIGN_IN')"
          class="link signin"
        >
          {{ $t('AUTH.SIGN_IN') }}
        </RouterLink>
        <div v-if="isAuthenticated" class="link setting">
          <div class="user" @click="toggleMobileDropdownUserOptions">
            <a class="user--avatar pointer" @click="goToMember">
              <div
                v-cover-lazy-loader
                :data-src="profile.avatar"
                :data-default-src="'/img/img-default/img-user-default-s.png'"
                :data-hide="true"
                class="avatar"
              />
            </a>
            <a class="user--name pointer" @click="goToMember">
              {{ profile.name }}
            </a>
            <div class="user-toggle">
              <i :class="{open: showMobileDropdownUserOptions}" class="icon-expand material-icons">
                expand_more
              </i>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <Transition name="expand">
      <div v-if="showMobileDropdown && showMobileDropdownUserOptions" class="header-dropdown--user">
        <span class="link pointer" @click="goToNotification">
          <i class="icon material-icons">
            notifications
          </i>
          <span class="text">
            {{ $t('MEMBER.NOTIFICATION.TITLE') }}
          </span>
        </span>
        <span class="link pointer" @click="logout">
          <i v-if="!siginOutLoading" class="icon material-icons">
            input
          </i>
          <span v-if="!siginOutLoading" class="text">
            {{ $t('AUTH.SIGN_OUT') }}
          </span>
          <Loader v-else :width="55" :height="55" />
        </span>
      </div>
    </Transition>
  </header>
</template>

<script>
import Logo from '@/components/common/Logo'
import Avatar from '@/components/common/Avatar'
import Loader from '@/components/common/Loader'
import SearchButton from '@/components/search/SearchButton'
import CoverLazyLoader from '@/directives/CoverLazyLoader'

export default {
  name: 'MuzikHeader',
  components: {
    Logo,
    Avatar,
    Loader,
    SearchButton
  },
  directives: {
    CoverLazyLoader
  },
  data() {
    return {
      showDropdown: false,
      showMobileDropdown: false,
      showMobileDropdownUserOptions: false,
      redirectPending: false,
      siginOutLoading: false
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    clientWidth() {
      return this.$store.state.clientWidth
    },
    profile() {
      return this.$store.state.user.profile
    },
    profileLoading() {
      return this.$store.state.user.status === 'pending'
    },
    currentURL() {
      return this.$route.path
    },
    AIR_URL() {
      return `https://${process.env.VUE_APP_MUZIK_AIR}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    LISTEN_URL() {
      return `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    READ_URL() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    CONCERT_URL() {
      return `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    WATCH_URL() {
      return `https://${process.env.VUE_APP_MUZIK_WATCH}.${process.env.VUE_APP_MUZIK_DOMAIN}`
    },
    MUZIK_SHOP_URL() {
      return `https://shop.muzik.com.tw/`
    }
  },
  watch: {
    clientWidth(val) {
      if (val >= 768) {
        if (this.showMobileDropdown) {
          this.showMobileDropdownUserOptions = false
          this.showMobileDropdown = false
        }
      } else if (this.showDropdown) {
        this.showDropdown = false
        this.showMobileDropdown = true
        this.showMobileDropdownUserOptions = false
      }
      if (val < 320) {
        // Oops...
        // Not supported screen width on this device
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    navOnClick(url) {
      this.$store.dispatch('GTAG_EVENT', {
        action: 'click',
        data: {
          event_category: 'outbound',
          event_label: url,
          transport_type: 'beacon',
          event_callback: function () {
            // document.location = url
          }
        }
      })
    },
    toggleDropdown(toggle) {
      if (typeof toggle === 'boolean') {
        this.showDropdown = toggle
      } else {
        this.showDropdown = !this.showDropdown
      }
    },
    toggleMobileDropdown(toggle) {
      if (typeof toggle === 'boolean') {
        this.showMobileDropdown = toggle
      } else {
        this.showMobileDropdown = !this.showMobileDropdown
      }
    },
    toggleMobileDropdownUserOptions(toggle) {
      if (typeof toggle === 'boolean') {
        this.showMobileDropdownUserOptions = toggle
      } else {
        this.showMobileDropdownUserOptions = !this.showMobileDropdownUserOptions
      }
    },
    goToMember() {
      if (this.profile) {
        this.$router.push({ name: 'memberPage', params: { id: this.profile.id } })
        if (this.showDropdown) this.showDropdown = false
        if (this.showMobileDropdown) {
          this.showMobileDropdown = false
          this.showMobileDropdownUserOptions = false
        }
      }
    },
    goToNotification() {
      if (this.profile) {
        this.$router.push({ name: 'notification', params: { id: this.profile.id } })
        if (this.showDropdown) this.showDropdown = false
        if (this.showMobileDropdown) {
          this.showMobileDropdown = false
          this.showMobileDropdownUserOptions = false
        }
      }
    },
    async logout() {
      this.siginOutLoading = true
      const response = await this.$store.dispatch('AUTH_LOGOUT')
      if (response) {
        this.showDropdown = false
        this.showMobileDropdown = false
        this.showMobileDropdownUserOptions = false
        this.$router.push({
          name: 'index',
          params: { locale: this.$i18n.localePath() }
        })
        this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_OUT_SUCCESS', type: 'success' })
      } else {
        this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_OUT_ERROR', type: 'error' })
      }
      this.siginOutLoading = false
    },
    disabledAuthLink() {
      this.redirectPending = true
      setTimeout(() => {
        this.redirectPending = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.report {
  display: inline-block;
  padding: 0 16px;
  height: 64px;
  line-height: 64px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  text-decoration: none;
  text-align: center;
  color: $link-hover;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: $link-hover;
  }
}
.arrow--up {
  position: absolute;
  top: -10px;
  // left: 50%;
  right: 16px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px;
  border-top-width: 0;
  border-color: transparent;
  border-bottom-color: darken(#f3f3f3, 5%);
  &::after {
    content: ' ';
    position: absolute;
    display: block;
    top: 3px;
    right: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px;
    border-top-width: 0;
    border-color: transparent;
    border-bottom-color: white;
  }
}

.dropdownBackdrop {
  z-index: 78;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background-color: transparent;
  // background: rgba(255, 255, 255, 0.7); // for testing
}

.header-dropdown {
  position: relative;
  &-container {
    z-index: 79;
    position: absolute;
    top: 8px;
    right: -8px;
    width: 290px;
    height: 165px;
    border: solid 1px #f7f7f7;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    > div {
      border-bottom: solid 1px #f7f7f7;
    }
    .user {
      width: 100%;
      height: 55px;
      line-height: 55px;
      color: $grey-7d;
      text-align: left;
      text-decoration: none;
      &--name {
        font-size: 16px;
        font-weight: 700;
        margin-left: 16px;
        color: $grey-7d;
        text-decoration: none;
      }
      &--avatar {
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        text-decoration: none;
        .avatar {
          width: 36px;
          height: 36px;
          border: solid 2px $theme-yellow;
          border-radius: 50%;
          vertical-align: middle;

          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
    }
    .link {
      display: block;
      width: 100%;
      height: 55px;
      line-height: 55px;
      letter-spacing: normal;
      color: $grey-7d;
      text-align: left;
      text-decoration: none;
      cursor: pointer;
      .icon {
        font-size: 20px;
      }
      .text {
        font-size: 16px;
        font-weight: 700;
      }
      .icon,
      .text {
        line-height: 55px;
        vertical-align: middle;
        margin-left: 16px;
      }
    }
    .link:hover {
      color: $link-hover;
    }
    &::before {
      z-index: 78;
      content: ' ';
      position: absolute;
      top: -11px;
      right: 15px;
      display: block;
      border-style: solid;
      border-color: transparent;
      border-width: 10px;
      border-top-width: 0;
      border-bottom-color: darken(#f3f3f3, 5%);
    }
    &::after {
      z-index: 80;
      content: ' ';
      position: absolute;
      top: -8px;
      right: 17px;
      display: block;
      border-style: solid;
      border-color: transparent;
      border-width: 8px;
      border-top-width: 0;
      border-bottom-color: #ffffff;
    }
  }
}

.header-dropdown--mobile {
  // display: none;
  width: 100vw;
  max-height: 385px;
  overflow: hidden;
  margin-left: -24px;
  // border: 1px solid #a10903;
  .link {
    display: block;
    width: 100vw;
    height: 64px;
    line-height: 64px;
    padding: 0 36px;
    text-align: left;
    text-decoration: none;
    color: $grey-7d;
    background-color: $grey-f3;
    font-size: 20px;
    font-weight: 500;
    &.active{
      background-color: $grey-ec;
    }
  }
  .link.current {
    color: $theme-red;
  }
  .link.signin {
    color: white;
    background-color: $theme-yellow;
    text-align: center;
  }
  .link.setting {
    display: inline-block;
    vertical-align: top;
    background-color: white;
    border-bottom: solid 1px $grey-ec;
    .user {
      cursor: pointer;
      &--avatar {
        display: inline-block;
        vertical-align: middle;
        margin: 16px 16px 16px 0;
        text-decoration: none;
        .avatar {
          width: 36px;
          height: 36px;
          border: solid 2px $theme-yellow;
          border-radius: 50%;
          vertical-align: middle;

          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
      &--name {
        display: inline-block;
        vertical-align: top;
        margin-right: 16px;
        max-width: 60%;
        color: $grey-7d;
        text-decoration: none;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &-toggle {
        float: right;
        .icon-expand {
          font-size: 20px;
          line-height: 64px;
          transition: transform 0.4s ease;
        }
        .icon-expand.open {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.header-dropdown--user {
  width: 100vw;
  height: 128px;
  overflow: hidden;
  margin-left: -24px;
  // border: 1px solid #a10903;
  border-bottom: 1px solid $grey-ec;
  .link {
    display: block;
    width: 100vw;
    height: 64px;
    line-height: 64px;
    padding: 0 36px;
    text-align: left;
    text-decoration: none;
    font-size: 20px;
    font-weight: 500;
    color: $grey-7d;
    background-color: white;
    .icon,
    .text {
      font-size: 20px;
      line-height: 64px;
      vertical-align: middle;
      margin-right: 16px;
    }
  }
  .link:hover {
    color: $link-hover;
  }
}

.header {
  display: block;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 $padding-lg-x1;
  text-align: left;
  // border: 1px solid a10903; // for testing
  &-container {
    position: relative;
    padding: 0;
  }
  .nav {
    display: inline-block;
    vertical-align: top;
    height: 64px;
    .link {
      display: inline-block;
      // width: 84px;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: normal;
      text-decoration: none;
      text-align: center;
      color: $grey-9b;
      margin: 0 24px;
      &.link-yellow{
        color: $theme-yellow;
        text-transform: uppercase;
        &:hover{
          color: $theme-yellow-hover;
        }
      }
      &.active{
        color: $theme-red;
        border-bottom: 2px solid $theme-red;
      }
    }
    .link:hover {
      color: $link-hover;
    }
    .menu {
      margin-left: 16px;
      color: $grey-50;
      vertical-align: middle;
      cursor: pointer;
      > i {
        vertical-align: middle;
        &:hover {
          color: $link-hover;
        }
      }
    }
  }
  .nav.info {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    height: 64px;
    &::before {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
    > * {
      vertical-align: middle;
    }
    .signin {
      color: $grey-9b;
      width: auto; // overwrite inherent .link
      padding: 0 16px; // overwrite inherent .link
    }
    .signin:hover {
      color: $link-hover;
    }
    .signup {
      width: auto; // overwrite inherent from .link
      // min-width: 64px;
      padding: 0 16px;
      margin: 8px 0 8px 0;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: $theme-yellow;
      border: solid 1px $theme-yellow;
      border-radius: 12px;
      background-color: white;
      outline: none;
      cursor: pointer;
      &:hover {
        color: $theme-yellow-hover;
        border: solid 1px $theme-yellow-hover;
      }
      &:active {
        color: $theme-yellow-active;
        border: solid 1px $theme-yellow-active;
      }
    }
    .searchBtn-container {
      display: inline-block;
      // height: 64px;
      // line-height: 64px;
    }
    .avatar-container {
      display: inline-block;
      vertical-align: middle;
      margin-left: 16px;
      // height: 64px;
      // line-height: 64px;
    }
  }
  .nav.mobile {
    display: none; // default, update in query media
    position: absolute;
    top: 0;
    right: 0;
    height: 64px;
    &::before {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
    > * {
      width: auto; // reset
      vertical-align: middle;
    }
  }
}
// must after header-dropdown class
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s linear;
}

.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}

@media only screen and (max-width: 1439.98px) {
}
@media only screen and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
  .header {
    padding: 0 $padding-xs-x1;
    .nav {
      .icon {
        font-size: 24px;
        line-height: 64px;
      }
    }
    .nav:not(.mobile) {
      display: none;
    }
    .nav.mobile {
      display: inline-block;
    }
  }
}
</style>
